import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-pager";
import BaseViewModel from "./../../factories/base-view-model2";
import * as moment from "moment";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
class Task extends BaseViewModel {
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.subscribe(this.BaoSearcherEnabledComputed, (enabled) => {
            this.BaoSearcherEnabled(enabled);
        });
    }
    UserTab: TabPage;
    Readonly = ko.observable(false);
    UserTabTitle = ko.observable<string>();
    CompleteDateJs = ko.observable<string>();
    StartDateJs = ko.observable<string>();
    EndDateJs = ko.observable<string>();
    InsertDate = ko.observable<any>();
    CompleteBy = ko.observable<string>();
    CompleteDateFormatted = ko.observable<string>();
    FolderStructureChecklistId = ko.observable<string>();
    Lat = ko.observable<any>();
    Lon = ko.observable<any>();
    AllowTemplateChange = ko.observable<boolean>(true);
    BaoSearcherEnabledComputed = ko.computed(() => {
        return this.AllowTemplateChange() && this.Readonly() == false;
    });
    BaoSearcherEnabled = ko.observable<boolean>(this.BaoSearcherEnabledComputed());
    private baoDateTimePickerStart: Bindings.baoDateTimePicker = {
        mode: 'datetime',
        showNavigation: true,
        disabled: this.Readonly
    };
    private baoDateTimePickerEnd: Bindings.baoDateTimePicker = {
        mode: 'datetime',
        showNavigation: true,
        minDate: this.StartDateJs,
        disabled: this.Readonly
    };
    private baoDateTimeBoxStart: Bindings.baoDateTimeBox = {
        culture: Bao.Session.Language.Symbol,
        mode: 'datetime',
        value: this.StartDateJs
    };
    private baoDateTimeBoxEnd: Bindings.baoDateTimeBox = {
        culture: Bao.Session.Language.Symbol,
        mode: 'datetime',
        value: this.EndDateJs
    };
    private baoSearcherTemplate: Bindings.baoSearcher = {
        ObjectId: this.FolderStructureChecklistId,
        SearchType: 'Checkware-FolderStructureChecklist',
        ObjectValue: 'ListName',
        AutoComplete: true,
        AutoSearch: true,
        Enabled: this.BaoSearcherEnabled
    };
    CompleteCheck() {
        var latValue = this.Lat();
        var indexValueLat = 3;
        if (latValue !== null && latValue.toString().lastIndexOf('-') !== -1) {
            indexValueLat = 4;
        }
        if (latValue !== null && (latValue.toString().lastIndexOf('.') > indexValueLat || latValue.toString().lastIndexOf('.') === -1 && latValue.toString().length > indexValueLat)) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgInvalidGps"), "info");
            return false;
        }
        var lonValue = this.Lon();
        var indexValueLon = 3;
        if (lonValue !== null && lonValue.toString().lastIndexOf('-') !== -1) {
            indexValueLon = 4;
        }
        if (lonValue !== null && (lonValue.toString().lastIndexOf('.') > indexValueLon || lonValue.toString().lastIndexOf('.') === -1 && lonValue.toString().length > indexValueLon)) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgInvalidGps"), "info");
            return false;
        }
        return true;
    }
    InitUrl() {
        return "Checkware/Task/Init";
    }
    Save() {
        return super.Save().then(() => {
            Bao.raiseEvent('checkware-tasks:refresh', null);
        });
    }
    init() {
        var def = $.Deferred<void>();
        super.init().then(() => {
            super.InitTabController().then(() => {
                this.UserTab = new TabPage();
                this.UserTab.IsClosable(false);
                this.UserTab.Url("Checkware/TaskUserTab");
                this.TabController.AddTab(this.UserTab);
                def.resolve();
            });
        });
        return def.promise();
    }
}
export default Task;